import React from 'react';
import { trackFrontendError } from '../lib/firstPartyAnalytics';

const sanitize = (value) => String(value || '')
  .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[email]')
  .replace(/\b\d{6}\b/g, '[code]')
  .replace(/https?:\/\/\S+/gi, '[url]')
  .slice(0, 180);

const classify = (error) => {
  const value = String(error?.message || '').toLowerCase();
  if (value.includes('removechild') || value.includes('not a child')) return 'DOM_REMOVE_CHILD';
  if (value.includes('insertbefore')) return 'DOM_INSERT_BEFORE';
  if (value.includes('chunkload') || value.includes('loading chunk')) return 'ASSET_CHUNK_LOAD';
  if (error?.name === 'NotFoundError') return 'DOM_NOT_FOUND';
  return 'REACT_RENDER_ERROR';
};

class GlobalErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { code: null, detail: null }; }
  static getDerivedStateFromError(error) {
    return {
      code: classify(error),
      detail: `${sanitize(error?.name || 'Error')}: ${sanitize(error?.message || 'no-message')}`,
    };
  }
  componentDidCatch(error) {
    const code = classify(error);
    trackFrontendError({ errorType: 'runtime_error', component: 'GlobalErrorBoundary', errorCode: code.toLowerCase() });
  }
  render() {
    if (!this.state.code) return this.props.children;
    return (
      <main className="min-h-screen bg-white p-6 text-center" role="alert" translate="no">
        <h1 className="mt-16 text-2xl font-semibold">Не удалось открыть следующий шаг</h1>
        <p className="mt-4 text-gray-600">Технический код: {this.state.code}</p>
        <p className="mx-auto mt-3 max-w-md break-words text-sm text-gray-500" data-testid="safe-error-detail">{this.state.detail}</p>
        <button type="button" className="mt-6 rounded-full bg-red-500 px-6 py-3 font-semibold text-white" onClick={() => window.location.reload()}>
          Обновить страницу
        </button>
      </main>
    );
  }
}

export default GlobalErrorBoundary;
